export default __webpack_public_path__ + "static/media/15.a49084d6.webp";